<div class="rfq-product-substitution-table__wrapper">
  <table class="lum-table lum-table--classic striped">
    <tr class="table__head-row">
      <th class="w-41"></th>
      <th>Name</th>
      <th>Priority</th>
      <th>Action</th>
    </tr>
    <tbody cdkDropList (cdkDropListDropped)="dropEvent.emit($event)">
      <ng-container
        *ngFor="
          let item of productSubstitutions | sortBy: 'priority';
          trackBy: trackById;
          let i = index
        "
      >
        <tr cdkDrag [cdkDragData]="item" cdkDragLockAxis="y" class="custom-row">
          <div class="drag-and-drop-placeholder" *cdkDragPlaceholder></div>
          <td>
            <lum-ui-icon
              cdkDragHandle
              class="mr-2 cursor-grab"
              icon="menu"
              color="#36363A"
            ></lum-ui-icon>
          </td>
          <td>
            [{{ item.substituteProduct?.internalSku }}]
            {{ item.substituteProduct?.productName }}
          </td>
          <td>
            {{ item.priority }}
          </td>
          <td>
            <button class="btn btn-danger" (click)="detachEvent.emit(i)">
              Delete
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>
